import React, {PropTypes} from 'react';
import {Button} from '@goguardian/based';

import style from './style.scss';

export default class VerificationError extends React.Component {

  toHomePage() {
    window.location = 'https://www.goguardian.com';
  }

  render() {

    return (
      <div className={style.vErrorContainer}>
        <h1>Account verification denied</h1>
        <p>Hmm, it doesn&#39;t seem like a Google Account with the right permissions exists. Please try again, or click below to return to our home page. </p>
        <p>Still having trouble? <br /><a href="mailto:support@goguardian.com">Our Support Team can help!</a></p>
        <Button onClick={this.toHomePage}>
          Return to Home Page
        </Button>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/verificationError/index.jsx
 **/